// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DeleteSiHaDocumentationRequestModel from '../../model/delete-si-ha-documentation-request-model';
import DeleteSiHaDocumentationRequestDTO from '../dto/delete-si-ha-documentation-request-dto';
import dtoSchema from '../schemas/delete-si-ha-documentation-request-schema';

export default abstract class DeleteSiHaDocumentationRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DeleteSiHaDocumentationRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<DeleteSiHaDocumentationRequestDTO>): DeleteSiHaDocumentationRequestModel;
  static toModel(dto: DeepPartial<DeleteSiHaDocumentationRequestDTO> | undefined | null): DeleteSiHaDocumentationRequestModel | undefined;
  static toModel(dto: DeepPartial<DeleteSiHaDocumentationRequestDTO> | undefined | null): DeleteSiHaDocumentationRequestModel | undefined {
    return dto ? new DeleteSiHaDocumentationRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DeleteSiHaDocumentationRequestModel> | DeleteSiHaDocumentationRequestModel): DeleteSiHaDocumentationRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as DeleteSiHaDocumentationRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DeleteSiHaDocumentationRequestModel, can not map to DeleteSiHaDocumentationRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
